export default __webpack_public_path__ + "static/char-v-17-957836f3f41bd810ab0f020933e37007.png";